import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from './UserAppResource';

export const NYLAS_ACCOUNT_TYPE = {
    CALENDAR: 'calendar',
    EMAIL: 'email',
    CONTACT: 'contact',
};


class NylasAccountAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'nylas-account';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'nylas/accounts';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'email',
            'accountId',
            'token',
            'provider',
            'userUuid',
            'user',
            'type',
            'enabled',
            'emailLimit',
            'isTokenValid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            user: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            user: 'user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            email: {
                type: 'string',
                presence: true,
            },
            accountId: {
                type: 'string',
                presence: true,
            },
            token: {
                type: 'string',
                presence: true,
            },
            provider: {
                type: 'string',
                presence: true,
            },
            userUuid: {
                type: 'string',
                presence: true,
            },
            type: {
                type: 'string',
                presence: true,
            },
            enabled: {
                type: 'boolean',
            },
            emailLimit: {
                type: 'integer',
            },
            isTokenValid :{
                type: 'boolean',
            }
        };
    }
}

export default NylasAccountAppResource;
